import { render } from "./PatientNewForm.vue?vue&type=template&id=c2faf410"
import script from "./PatientNewForm.vue?vue&type=script&lang=js"
export * from "./PatientNewForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__